module.exports = {"222403001":"渤海街道","222403002":"胜利街道","222403003":"民主街道","222403004":"丹江街道","222403100":"大石头镇","222403101":"黄泥河镇","222403102":"官地镇","222403103":"沙河沿镇","222403104":"秋梨沟镇","222403105":"额穆镇","222403106":"贤儒镇","222403107":"大蒲柴河镇","222403108":"雁鸣湖镇","222403109":"江源镇","222403110":"江南镇","222403200":"大桥乡","222403201":"黑石乡","222403202":"青沟子乡","222403203":"翰章乡","222403204":"红石乡","222403400":"长白山森工集团敦化林业有限公司","222403401":"长白山森工集团黄泥河林业有限公司","222403402":"长白山森工集团大石头林业有限公司","222403403":"敦化市林业局","222403404":"敖东鹿场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222403.json
// module id = 755
// module chunks = 0